export enum ContractStatusType {
    ACTIVE = 'ACTIF',
    CANCELED = 'RESILIE',
    SUSPENDED = 'SUSPENDU',
}

export enum MarketLineType {
    FAI = 'FAI',
    FB = 'FB',
    FNB = 'FNB',
    PP = 'PP',
}

export type ContractType = {
    id: string;
    lineType: string;
    statusChangeDate: string;
    subscription: {
        offerId: string;
        label: string;
        mobileDataOffer: boolean;
        isPremium: boolean;
        isSowo: boolean;
        activationDate: string;
    };
    phoneNumber: string;
    status: ContractStatusType;
    creationDate: string;
    marketLine: MarketLineType;
    user: {
        rightsProfileLabel: string;
        rightsProfile: string;
    };
    isRenewalEligible: boolean;
    iban?: string;
    mobile: {
        gencode?: string;
        brand?: string;
        name?: string;
    } | null;
};
